import React, { useState, useEffect } from "react";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom/dist";
import Swal from "sweetalert2";
const actionToBeTakenInputsTemplate = [
  {
    name: "actiontobetaken",
    label: "Call Disposition",
    type: "dropdown",
    required: true,
    gridClass: "col-lg-3",
    validation: {
      required: true,
    },
    options: [],
  },
  {
    name: "actiontobetakendate",
    label: "Follow Up Date and Time",
    minDate: new Date(),
    type: "datetime",
    required: true,
    gridClass: "col-lg-3",
    validation: {
      required: true,
    },
  },
  {
    name: "status",
    label: "Status",
    type: "dropdown",
    required: true,
    gridClass: "col-lg-3",
    validation: {
      required: true,
    },
    options: [],
  },
  {
    name: "remark",
    label: "Remark",
    type: "text",
    required: true,
    placeholder: "Text Here..",
    gridClass: "col-lg-3",
    validation: {
      required: true,
      message: "Remark is required",
    },
  },
];
const ActionToBeTaken = ({ onActionSubmitted }) => {
  const [formData, setFormData] = useState({});
  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [actionToBeTakenInputs, setActionToBeTakenInputs] = useState(actionToBeTakenInputsTemplate);
  const [validationErrors, setValidationErrors] = useState({});
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const location = useLocation();
  const lead_id = location?.state?.data?.lead_id || location?.state?.data ;
  console.log("lead_id////", location, lead_id);


  useEffect(() => {
    fetchActionToBeTakenOptions();
    fetchActionTakenOptions();
    // handleTransactions();
  }, []);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    //handleTransactions(newPage);
  };


  const fetchActionToBeTakenOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/actiontobetaken/ddlactiontobetaken",
        {
          business_partner_id: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const options = response.data.data.data.map((level) => ({
        label: level.NAME,
        value: level.ID,
      }));

      setActionToBeTakenInputs((prevInputs) =>
        prevInputs.map((input) =>
          input.name === "status" ? { ...input, options } : input
        )
      );
    } catch (error) {
      console.error("Error fetching action to be taken options:", error);
    }
  };

  const fetchActionTakenOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/actiontaken/ddlactiontaken",
        {
          business_partner_id: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const options = response.data.data.data.map((level) => ({
        label: level.NAME,
        value: level.ID,
      }));

      setActionToBeTakenInputs((prevInputs) =>
        prevInputs.map((input) =>
          input.name === "actiontobetaken" ? { ...input, options } : input
        )
      );
    } catch (error) {
      console.error("Error fetching action taken options:", error);
    }
  };

  const handleFormSubmit = async (data) => {
    const errors = {};
    let isValid = true;
  
    console.log("data>>>", data);
  
    actionToBeTakenInputsTemplate.forEach((field) => {
      if (field.required && !data[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (field.validation && field.validation.pattern && !field.validation.pattern.test(data[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    // Show confirmation alert before submitting the form
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to Add This Disposition?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Proceed with the form submission
          await axiosInstance.post(
            "/lead/createtransaction",
            {
              lead_id: lead_id,
              business_partner_id: 1,
              action_taken_id: data?.actiontobetaken,
              action_tobe_taken_id: data?.status,
              action_tobe_taken_datetime: data?.actiontobetakendate,
              action_tobe_taken_remarks: data?.remark,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              }
            }
          );
  
          // Success alert after form submission
          Swal.fire({
            title: "Success!",
            text: "Disposition added successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
  
          if (onActionSubmitted) {
            onActionSubmitted();
          }
  
          // Clear the form inputs
          setFormData({});
          
        } catch (error) {
          const errorMessage = error.response?.data?.message || "Failed to add action. Please try again.";
  
          // Error alert if the form submission fails
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
  
          console.error("Error submitting form:", error);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User cancelled the submission
        Swal.fire({
          title: "Cancelled",
          text: "Action submission cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };
  
  // const handleFormSubmit = async (data) => {
  //   const errors = {};
  //   let isValid = true;

  //   console.log("data>>>", data);

  //   actionToBeTakenInputsTemplate.forEach((field) => {
  //     if (field.required && !data[field.name]) {
  //       errors[field.name] = "This field is required";
  //       isValid = false;
  //     } else if (field.validation && field.validation.pattern && !field.validation.pattern.test(data[field.name])) {
  //       errors[field.name] = field.validation.message;
  //       isValid = false;
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   try {
  //     await axiosInstance.post(
  //       "/lead/createtransaction",
  //       {
  //         lead_id: lead_id,
  //         business_partner_id: 1,
  //         action_taken_id: data?.actiontobetaken,
  //         action_tobe_taken_id: data?.status,
  //         action_tobe_taken_datetime: data?.actiontobetakendate,
  //         action_tobe_taken_remarks: data?.remark,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         }
  //       }
  //     );
  //     //toastSuccess("Action to be taken added successfully!");

  //     if (onActionSubmitted) {
  //       onActionSubmitted();
  //     }

  //     // Clear the form inputs
  //     setFormData({});


  //   } catch (error) {
  //     const errorMessage = error.response?.data?.message || "Failed to add action. Please try again.";
  //     // toastError(errorMessage);
  //     console.error("Error submitting form:", error);
  //   }
  // };

  return (
    <>
      <ToastContainer />
      <div className="row">
        <div className="col-lg-11">
          <DynamicForm
            formConfig={actionToBeTakenInputs}
            formData={formData}
            setFormData={setFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            onSubmit={handleFormSubmit}
            showParentDesignation={showParentDesignation}
          />
        </div>
        <div className="actiontobetakenbtncontainer mt-4 col-lg-1">
          <button
            onClick={() => handleFormSubmit(formData)}
            className="submit-btn"
          >
            Update
          </button>
        </div>
      </div>
    </>
  );
};

export default ActionToBeTaken;


